<div class="chart-container" style="width: 400px;">
  <canvas id="reportChart">{{ chart }}</canvas>
</div>
